.link-icon{border:2px solid #e2e2e2;border-radius:50%;padding:2px 4px}
/*# sourceMappingURL=balance-widget.component-PH6I4W77.css.map */
